<template>
  <div class="page no-margin">
    <div v-if="getAttribute('loading') || !getAttribute('dates').length" class="spinner-container">
      <div class="spinner"></div>
    </div>
    <template v-else>
      <MSelect v-model="filter.country" label="Country:" placeholder="All" col="4" :options="getAttribute('countries')" />
      <MSelect
        v-model="filter.date"
        label="Store invoice payment dates:"
        placeholder="Select a date"
        col="8"
        :options="getAttribute('dates')"
      />
      <div class="cards-container">
        <div v-for="item in getAttribute('storeInvoicePayments')" :key="item.id">
          <InvoicePayment
            :key="item.id"
            :invoice-payment="item"
            :invoice-links="{
              PDF: `${baseApiUrl}/stores/${item.store.id}/invoices/${item.id}/pdf`,
            }"
            :on-approvement-change="changeApprovement"
            :on-recalculation="recalculate"
            :on-create-credit-invoice="createCreditInvoice"
            :change-approvement-loading="getAttribute('approvementLoading')"
            :recalculation-loading="getAttribute('recalculationLoading')"
            :is-creating-credit-invoice="getAttribute('isCreatingCreditInvoice')"
            :credit-invoice-link="getCreditInvoiceLInk(item)"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import MSelect from '../../components/metapic/inputs/MSelect.vue'
import InvoicePayment from '../../components/InvoicePayment.vue'
import { config } from '@/lib/helpers/config.helpers'
export default {
  components: {
    MSelect,
    InvoicePayment,
  },
  data() {
    return { baseApiUrl: config.apiBaseUrl }
  },
  computed: {
    ...mapGetters('storeInvoicePayments/list', ['filter', 'getAttribute']),
  },
  watch: {
    filter: {
      handler() {
        this.search()
      },
      deep: true,
    },
  },
  created() {
    this.getDates()
    this.search()
  },
  methods: {
    ...mapActions('storeInvoicePayments/list', ['getDates', 'search', 'changeApprovement', 'recalculate', 'createCreditInvoice']),
    ...mapMutations('storeInvoicePayments/list', ['update']),
    getCreditInvoiceLInk(item) {
      if (item.credit_invoice_url) {
        return `${config.apiBaseUrl}/stores/${item.store.id}/invoices/${item.id}/pdf?get_credit=true`
      }
    },
  },
}
</script>

<style scoped>
.cards-container {
  margin-top: 90px;
  width: 99%;
}

.spinner-container {
  position: absolute !important;
  top: 5%;
  left: 0;
}
</style>
